import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import Wines from './pages/Wines';
import Cocktails from './pages/Cocktails';
import Family from './pages/Family';
import VisitUs from './pages/VisitUs';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <div className="relative min-h-screen flex flex-col bg-dark text-creme antialiased overflow-x-hidden">
      {/* Scroll restoration */}
      <ScrollToTop />

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/the-wines" element={<Wines />} />
          <Route path="/the-cocktails" element={<Cocktails />} />
          <Route path="/the-family" element={<Family />} />
          <Route path="/visit-us" element={<VisitUs />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
